import { z } from 'zod';
/**
 * The model endpoint a learner's coding agent talks to. The platform delivers it to
 * the workspace VM at every IDE launch; the credential identifies the workspace, not
 * the learner's account, and the gateway decides per request whether it still applies.
 */
export const workspaceAgentSchema = z
    .object({
    baseUrl: z.url().max(512),
    model: z.string().regex(/^[a-z0-9][a-z0-9._:-]{0,127}$/),
    token: z.string().regex(/^mio_[A-Za-z0-9_-]{22}_[A-Za-z0-9_-]{43}$/),
})
    .strict();
export const configureAgentSchema = z
    .object({ workspaceId: z.uuid(), agent: workspaceAgentSchema })
    .strict();
export const agentConfiguredSchema = z
    .object({
    workspaceId: z.uuid(),
    model: z.string(),
    /** Home-relative paths the bridge wrote, for operator diagnostics only. */
    files: z.array(z.string().max(256)).max(8),
})
    .strict();
